<template>
  <div class="section-payment" id="section-payment">
    <p class="text-payment">El pago lo puedes realizar a través de:</p>
    <div class="wrapper-payment">
      <p class="text-bank">BANCO INTERNACIONAL</p>
      <p class="mb-0">Cuenta corriente:</p>
      <p class="text-num">Nº: 3500613691</p>
      <p class="mb-0">QUIPUSOFT S.A <br/>RUC: 1792997178001</p>
    </div>
  </div>
</template>
<script>
export default {
	name: 'section-payment',
};
</script>
<style lang="scss" scoped>
	.section-payment {
		background: color(faq-background);
		padding: 60px 7%;
	}

	.text-payment {
		color: color(title-green);
		font-size: 30px;
		font-weight: 600;
		text-align: center;
	}

	.wrapper-payment {
		border-radius: 18px;
    box-shadow: 0 2px 20px 0 rgba(0,0,0,.06);
		background: color(white);
		color: color(span-text);
		margin: auto;
		font-size: 20px;
		padding: 20px;
		width: 290px;
	}

	.text-bank {
		font-weight: 600;
	}

	.text-num {
		color: color(green-dark);
		font-weight: 600;
	}
</style>


// WEBPACK FOOTER //
// src/components/generate-app/section-payment.vue